import React from "react";

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import dressCodeImg from '../../../assets/img/palette.jpg';
import { Question } from "../../../types/types";


export const faqData: Question[] = [
        {
            id: 'q1',
            question: 'Puis-je venir avec mon/ma partenaire ?',
            answer: (
                <Typography>
                    Si votre partenaire est convié·e, son nom est inscrit sur l’enveloppe du
                    faire-part que vous avez reçu ou bien nous vous avons contacté(e) directement. N’hésitez pas à nous demander en cas de doute.
                </Typography>
            ),
        },
        {
            id: 'q2',
            question: 'Puis-je venir avec mes enfants ?',
            answer: (
                <Typography>
                    Les enfants sont les bienvenus !
                </Typography>
            ),
        },
        {
            id: 'q3',
            question: 'Y a-t-il un code vestimentaire ?',
            answer: (
                <Box>
                    <Typography sx={{mb: 2}}>
                        Le thème du mariage est dans les tons verts. Libre à vous de porter ces couleurs
                        ou votre tenue favorite : venez comme vous êtes !
                    </Typography>
                    <Box
                        component="img"
                        src={dressCodeImg}
                        alt="Exemples de couleurs pour le dress code"
                        sx={{
                            width: '100%',
                            maxWidth: 300,
                            borderRadius: 2,
                        }}
                    />
                </Box>
            ),
        },
        {
            id: 'q4',
            question: 'Où puis-je loger le soir du mariage ?',
            answer: (
                <>
                    <Typography sx={{mb: 1}}>
                        Le Domaine de la Pépinière dispose de nombreuses chambres.
                    </Typography>
                    <Link href="/stay" underline="hover">
                        Voir la page Loger
                    </Link>
                </>
            ),
        },
        {
            id: 'q5',
            question: 'Où puis-je trouver des informations sur le stationnement ?',
            answer: (
                <>
                    <Typography sx={{mb: 1}}>
                        Des informations détaillées sur le stationnement sont disponibles.
                    </Typography>
                    <Link href="/howtocome" underline="hover">
                        Voir la page Venir
                    </Link>
                </>
            ),
        },
        {
            id: 'q6',
            question: 'Le mariage se déroule-t-il à l’intérieur ou à l’extérieur ?',
            answer: (
                <Typography>
                    Si le temps le permet, la plupart des moments du mariage se dérouleront à l’extérieur.
                    Pensez à prévoir de quoi vous protéger du soleil ou de la fraîcheur du soir.
                </Typography>
            ),
        },
        {
            id: 'q7',
            question: 'Le transport entre les lieux est-il assuré ?',
            answer: (
                    <Typography>
                        Le transport entre la mairie et le Domaine de la Pépinière n’est pas assuré, comptez environ 50 minutes entre les deux.
                        N’hésitez pas à covoiturer.
                    </Typography>
            ),
        },
        {
            id: 'q8',
            question:
                'À quelle heure faut-il arriver ?',
            answer:
                (
                    <Typography>
                        La cérémonie civile a lieu à 15h. Merci d’arriver 15 minutes avant la cérémonie.
                    </Typography>
                ),
        }
        ,
        {
            id: 'q9',
            question:
                'J’aimerais intervenir pendant la journée (discours, animation…). À qui m’adresser ?',
            answer:
                (
                    <>
                        <Typography>
                            Les discours et animations sont gérés par nos témoins.
                            Si vous souhaitez intervenir, merci de les contacter directement :
                        </Typography>
                        <Box component="ul" sx={{pl: 3, mb: 1}}>
                            <li>
                                <Box sx={{display: 'flex', alignItems: 'center'}}>

                                    <Typography variant="body1"><strong>Zoé</strong> : 06 95 67 78 99</Typography>
                                </Box>
                            </li>
                            <li>
                                <Box sx={{display: 'flex', alignItems: 'center'}}>
                                    <Typography variant="body1"><strong>Morgan</strong> : 07 77 81 33 11</Typography>
                                </Box>
                            </li>
                        </Box>
                    </>
                ),
        }
        ,
        {
            id: 'q10',
            question:
                'Puis-je amener mon animal ?',
            answer:
                (
                    <Typography>
                        Les animaux ne sont malheureusement pas autorisés au domaine.
                    </Typography>
                ),
        }
        ,
    ]
;


const QuestionsList: React.FC = () => {
    return (
        <Box
            sx={{
                maxWidth: 800,
                mx: 'auto',
                p: 2,
            }}
        >
            {faqData.map((item) => (
                <Accordion key={item.id} sx={{mb: 1 , "&::before": {
                        display: "none",
                    },}}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
                        <Typography component="span" fontWeight={500}>
                            {item.question}
                        </Typography>
                    </AccordionSummary>

                    <AccordionDetails>
                        {item.answer}
                    </AccordionDetails>
                </Accordion>
            ))}
        </Box>
    );
};

export default QuestionsList;